import dataOverview from './paths/dataOverview';
import smartMarketing from './paths/smartMarketing';
import userManagement from './paths/userManagement';
import audienceManagement from './paths/audienceManagement';
import settings from './paths/settings';

// Layouts
import defaultLayout from '@/layouts/Default.vue';

const errorPage = () => import('@/pages/Error.vue');
const login = () => import('@/pages/Login.vue');
const passReset = () => import('@/pages/PassReset.vue');

const routes = [
  {
    path: '/',
    name: 'index',
    meta: {
      requiresAuth: true
    },
    redirect: {
      name: 'dataOverview'
    },
    component: defaultLayout,
    children: [dataOverview, audienceManagement, smartMarketing, userManagement, settings]
  },
  {
    name: 'login',
    path: '/login',
    meta: {
      guest: true
    },
    component: login
  },
  {
    name: 'passwordReset',
    path: '/password-reset',
    meta: {
      guest: true
    },
    component: passReset
  },
  {
    name: 'error',
    path: '/error',
    meta: {
      guest: true
    },
    component: errorPage
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/error'
  }
];

export default routes;
